import { AnyAction } from "redux";
import {
  FETCH_SEARCH_PRODUCTS_ERROR,
  FETCH_SEARCH_PRODUCTS_SUCCESS,
  REQUEST_SEARCH_PRODUCTS,
} from "redux/actions/products/search";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_SEARCH_PRODUCTS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SEARCH_PRODUCTS_SUCCESS:
      return {
        data: action.searchResult,
        error: null,
        loading: false,
      };
    case FETCH_SEARCH_PRODUCTS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
